import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ hasFilters, onClearFilters }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (hasFilters) {
    return (
      <div className="bg-card rounded-lg border border-border p-8 md:p-12 text-center shadow-elevation-sm">
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-muted mx-auto mb-4 flex items-center justify-center">
          <Icon name="Search" size={32} className="text-muted-foreground md:w-10 md:h-10" />
        </div>
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2">{t('dashboard.empty.title')}</h3>
        <p className="text-sm md:text-base text-muted-foreground mb-6 max-w-md mx-auto">
          {t('dashboard.empty.noResults')}
        </p>
        <Button
          variant="outline"
          onClick={onClearFilters}
          iconName="X"
          iconPosition="left"
        >
          {t('dashboard.empty.clearFilters')}
        </Button>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-8 md:p-12 text-center shadow-elevation-sm">
      <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-accent/10 mx-auto mb-4 flex items-center justify-center">
        <Icon name="BookOpen" size={32} className="text-accent md:w-10 md:h-10" />
      </div>
      <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2">{t('dashboard.empty.title')}</h3>
      <p className="text-sm md:text-base text-muted-foreground mb-6 max-w-md mx-auto">
        {t('dashboard.empty.description')}
      </p>
      <Button
        variant="default"
        onClick={() => navigate('/pdf-upload')}
        iconName="Plus"
        iconPosition="left"
      >
        {t('dashboard.empty.createButton')}
      </Button>
    </div>
  );
};

export default EmptyState;